/// <reference path="../typings/index.d.ts" />
namespace App.Modulos {
  export class FiltrosEa {
    public static inicializar() {
      var filtrosEa = new App.FiltrosEa();
      filtrosEa.inicializarEventos();
    }
  }
}

namespace App {
  export class FiltrosEa {
    private elCampoMinFiltro: JQuery = $("input[name=minBuyNow]");
    private elCampoValorMaximo: JQuery = $("input[name=maxBuyNow]");
    private elCampoVariar: JQuery = $("input[name=variar]");
    private elCampoValorVenda: JQuery = $("input[name=valor_venda]");
    private elCampoValorLanceMinimoVenda: JQuery = $("input[name=valor_lance_minimo]");
    public elAtivarVendaAutomatica: JQuery = $("input[name=ativar_venda_automatica]");
    private elRadioPreco: JQuery = $("input[name=precoCompra]");
    private objSelect2: ISelect2 = null;
    private elCampoRaridade: JQuery = $("select[name='rarity[]']");

    private elCampoLimitePrecoCompraMin: JQuery = $("input[name=limite_compra_min]");
    private elCampoLimitePrecoCompraMax: JQuery = $("input[name=limite_compra_max]");

    public inicializarEventos(contexto: any = null) {
      this.objSelect2 = new Select2();
      this.objSelect2.inicializarCampo($('.select-filtros'), {
        width: '100%',
        templateResult: formatOptionsSelect,
        templateSelection: formatOptionsSelect
      });
      $(".campo-jogador").select2({
        ajax: {
          dataType: 'json',
          delay: 1000,
          allowClear: true,
          url: function (params: any) {
            return '/jogador/' + params.term;
          },
          processResults: function (data: any, params: any) {
            params.page = params.page || 1;

            return {
              results: data,
              pagination: {
                more: (params.page * 30) < data.total_count
              }
            };
          },
          cache: true
        },
        width: '100%',
        placeholder: 'Encontrar jogador',
        escapeMarkup: function (markup: any) {
          return markup;
        }, // let our custom formatter work
        minimumInputLength: 1,
        templateResult: formatRepoJogador,
        templateSelection: formatRepoJogador,
        language: {
          inputTooShort: function () {
            return "Informe parte do nome do jogador...";
          },
          inputTooLong: function (args: any) {
            return "Você digitou muito";
          },
          errorLoading: function () {
            return "Nada encontrado";
          },
          loadingMore: function () {
            return "Procurando resultados";
          },
          noResults: function () {
            return "Nada encontrado";
          },
          searching: function () {
            return "Procurando...";
          },
          maximumSelected: function (args: any) {
            return "Nada encontrado";
          }
        }
      });

      $('.campo-jogador').on('select2:select', function (e) {
        if ($(this).val() != "0") {
          $('#searchclear').show();
        } else {
          $('#searchclear').hide();
        }
      });

      $("#searchclear").click(function () {
        $(this).hide();
        $("#imgJogador").attr('src', "images/default.png");
        $(".campo-jogador").select2('val', '0');
        $('.campo-jogador').find("option").remove();
      });

      var botaoIcrementDecrement = new BotaoIncrementDecrementEa();
      botaoIcrementDecrement.inicializarEventos();
      this.elAtivarVendaAutomatica.on('change', (e) => { this.aoSelecionarVendaAutomatica(e); });
      this.elCampoValorMaximo.on('change keyup', (e) => { this.aoInformarValor(e); });
      this.elCampoVariar.on('change keyup', (e) => { this.aoAlterarVariacaoPrecoCompra(e); });
      this.elCampoValorMaximo.on('focusout', (e) => { this.aoPerderFocoCampoValor(e); });
      this.elCampoValorVenda.on('focusout', (e) => { this.aoPerderFocoCampoValor(e); });
      this.elCampoValorLanceMinimoVenda.on('focusout', (e) => { this.aoPerderFocoCampoValor(e); });
      this.elCampoMinFiltro.on('focusout', (e) => { this.aoPerderFocoCampoValor(e); });
      this.elRadioPreco.on('change', (e) => { this.aoSelecionarTipoPrecoCompra(e); });

      this.elCampoLimitePrecoCompraMin.on('focusout', (e) => { this.aoPerderFocoCampoValor(e); });
      this.elCampoLimitePrecoCompraMax.on('focusout', (e) => { this.aoPerderFocoCampoValor(e); });

      this.elCampoRaridade.on("select2:select", (e) => { this.aoSelecionarCampoRaridade(e); });
      this.elCampoRaridade.on("select2:unselect", (e) => { this.aoSelecionarCampoRaridade(e); });
    }

    private aoSelecionarCampoRaridade(e: any) {
      let raridadesIds: number[] = $(e.target).val();
      if (raridadesIds.length) {
        $(e.target).addClass('raridade-selecionada')
      } else {
        $(e.target).removeClass('raridade-selecionada')
      }

      if (raridadesIds.length > 1 || raridadesIds.filter(value => App.Util.config.idsRaridadesComRisco.includes(value)).length) {
        $(e.target).parents(".form-group").find("#alertRaridadeRisco").show()
      } else {
        $(e.target).parents(".form-group").find("#alertRaridadeRisco").hide()
      }
    }


    private aoSelecionarVendaAutomatica(e: JQueryEventObject) {
      if ($(e.target).is(':checked')) {
        this.habilitarVendaAutomatica(e);
      } else {
        this.desabilitarVendaAutomatica(e);
      }
    }
    private aoSelecionarTipoPrecoCompra(e: JQueryEventObject) {
      if ($(e.target).val() == '1') {
        this.habilitarPrecoFixo(e);
        this.desabilitarPrecoLucro(e);
      } else {
        this.desabilitarPrecoFixo(e);
        this.habilitarPrecoLucro(e);
      }
    }

    private habilitarPrecoFixo(e: JQueryEventObject) {
      var parent = $(e.target).parents('.parent-filtro');
      parent.find('.conteudo-ofertas-venda').show();

    }
    private desabilitarPrecoFixo(e: JQueryEventObject) {
      var parent = $(e.target).parents('.parent-filtro');
      parent.find('.conteudo-ofertas-venda').hide();

    }
    private habilitarPrecoLucro(e: JQueryEventObject) {
      var parent = $(e.target).parents('.parent-filtro');
      parent.find('.conteudo-ofertas-por-lucro').show();

    }
    private desabilitarPrecoLucro(e: JQueryEventObject) {
      var parent = $(e.target).parents('.parent-filtro');
      parent.find('.conteudo-ofertas-por-lucro').hide();

    }
    private habilitarVendaAutomatica(e: JQueryEventObject) {
      var parent = $(e.target).parents('form');
      parent.find('.conteudoVendaAutomatica :input').prop("disabled", false).val("");
      parent.find('.conteudoVendaAutomatica .input-group-prepend').removeClass("disabled");
      $(".corpoVendaAutomatica").show();
      $(".labelVendaAutomatica").removeClass('text-muted').addClass('text-primary');
    }

    private desabilitarVendaAutomatica(e: JQueryEventObject) {
      var parent = $(e.target).parents('form');
      parent.find('.conteudoVendaAutomatica :input').prop("disabled", true).val("");
      parent.find('.conteudoVendaAutomatica .input-group-prepend').addClass("disabled");
      $(".corpoVendaAutomatica").hide();
      $(".labelVendaAutomatica").removeClass('text-primary').addClass('text-muted');
    }


    private aoPerderFocoCampoValor(e: JQueryEventObject) {
      var parent: any = $(e.target).parents('form');
      var campoName = $(e.target).attr('name');
      var campoContextoValorMin = $(e.target).data('min');

      var valorInformado: any = App.Util.obterInteiroDaString($(e.target).val());
      valorInformado = valorInformado ? valorInformado : 0;
      switch (campoName) {
        case 'minBuyNow':
          valorInformado = valorInformado > App.SniperExtensao.valorCoinMax ? App.SniperExtensao.valorCoinMax : valorInformado;
          var valorCampoMax = App.Util.obterInteiroDaString(parent.find(this.elCampoValorMaximo).val());
          if (valorInformado >= valorCampoMax) {
            parent.find(this.elCampoValorMaximo).val(valorInformado < App.SniperExtensao.valorCoinMax ? App.Util.incrementarValorDeFiltro(valorInformado) : App.SniperExtensao.valorCoinMax).trigger('input').trigger('change');
          }
          break;
        case 'valor_lance_minimo':
          valorInformado = valorInformado > App.SniperExtensao.valorCoinMax ? App.SniperExtensao.valorCoinMax : valorInformado;
          var valorCampoMax = App.Util.obterInteiroDaString(parent.find(this.elCampoValorVenda).val());
          if (valorInformado >= valorCampoMax) {
            parent.find(this.elCampoValorVenda).val(valorInformado < App.SniperExtensao.valorCoinMax ? App.Util.incrementarValorDeFiltro(valorInformado) : App.SniperExtensao.valorCoinMax).trigger('input').trigger('change');
          }
          valorInformado = valorInformado ? valorInformado : 0;
          break;
        case 'maxBuyNow':
          var valorCampoMin = App.Util.obterInteiroDaString(parent.find(this.elCampoMinFiltro).val());
          if (valorInformado <= valorCampoMin) {
            var valorCalculado = App.Util.decrementarValorDeFiltro(valorInformado);
            var valorMinCampo = parent.find(this.elCampoMinFiltro).data('min');
            parent.find(this.elCampoMinFiltro).val(valorCalculado < valorMinCampo ? '' : valorCalculado).trigger('input');
          }
          valorInformado = valorInformado && valorInformado >= campoContextoValorMin ? (valorInformado > App.SniperExtensao.valorCoinMax ? App.SniperExtensao.valorCoinMax : valorInformado) : campoContextoValorMin;
          break;
        case 'valor_venda':
          var valorCampoMin = App.Util.obterInteiroDaString(parent.find(this.elCampoValorLanceMinimoVenda).val());
          if (valorInformado <= valorCampoMin) {
            var valorCalculado = App.Util.decrementarValorDeFiltro(valorInformado);
            parent.find(this.elCampoValorLanceMinimoVenda).val(valorCalculado <= 0 ? '' : valorCalculado).trigger('input');
          }
          valorInformado = valorInformado ? (valorInformado > App.SniperExtensao.valorCoinMax ? App.SniperExtensao.valorCoinMax : valorInformado) : 0;
          break;
        case 'limite_compra_min':
          valorInformado = valorInformado > App.SniperExtensao.valorCoinMax ? App.SniperExtensao.valorCoinMax : valorInformado;
          var valorCampoMax = App.Util.obterInteiroDaString(parent.find(this.elCampoLimitePrecoCompraMax).val());

          if (valorInformado >= valorCampoMax) {
            valorInformado = valorInformado < 200 ? 200 : valorInformado;
            parent.find(this.elCampoLimitePrecoCompraMax).val(valorInformado < App.SniperExtensao.valorCoinMax ? App.Util.incrementarValorDeFiltro(valorInformado) : App.SniperExtensao.valorCoinMax).trigger('input').trigger('change');
          }
          break;
        case 'limite_compra_max':
          var valorCampoMin = App.Util.obterInteiroDaString(parent.find(this.elCampoLimitePrecoCompraMin).val());
          if (valorInformado <= valorCampoMin) {
            var valorCalculado = App.Util.decrementarValorDeFiltro(valorInformado);
            var valorMinCampo = parent.find(this.elCampoLimitePrecoCompraMin).data('min');
            parent.find(this.elCampoLimitePrecoCompraMin).val(valorCalculado < valorMinCampo ? '' : valorCalculado).trigger('input');
          }
          valorInformado = valorInformado && valorInformado >= campoContextoValorMin ? (valorInformado > App.SniperExtensao.valorCoinMax ? App.SniperExtensao.valorCoinMax : valorInformado) : '';
          break;
      }

      valorInformado = App.Util.tratarValorDeFiltro(valorInformado);
      $(e.target).val(valorInformado ? valorInformado.toString() : '').trigger('input').trigger('change');
    }

    private aoInformarValor(e: JQueryEventObject) {
      var valorInformado = App.Util.obterInteiroDaString($(e.target).val());
      if (valorInformado > 100000) {
        $(e.target).css({ 'background-color': '#ffffff' }).css({ 'color': '#bbc60c' });
        $(e.target).parents('.input-group').find('.input-group-text').css({ 'background-color': '#ffffff' });
        $("#alertValor").show();
      } else {
        $(e.target).css({ 'background-color': '#ffffff' }).css({ 'color': '#38a378' });
        $(e.target).parents('.input-group').find('.input-group-text').css({ 'background-color': '#ffffff' });
        $("#alertValor").hide();
      }
      $(e.target).parents('.modal').find('input[name=variar]').trigger('input').trigger('change');
    }

    public setCampoInputCheckbox(name: string, checked: boolean = true) {
      $("input[name='" + name + "']").prop('checked', checked).trigger('change');
    }
    public setCampoInputRadio(name: string, valor: any = null) {
      $("input[name='" + name + "'][value='" + valor + "']").prop('checked', true).trigger('change');
    }
    public setCampoInputName(name: string, valor: any = null, propagar: boolean = false) {
      var seletor = "input[name='" + name + "']";
      var form: JQuery = $(seletor).parents('form');
      if (propagar) {
        form.find(seletor).val(valor).trigger('input').trigger('change');
      } else {
        form.find(seletor).val(valor);
      }
    }

    public setCampoSelect2(name: string, valor: any = null) {
      var seletor = "select[name='" + name + "']";
      var form: JQuery = $(seletor).parents('form');
      form.find(seletor).val(valor).trigger('change').trigger('select2:select');
    }

    public setCampoJogador(maskedDefId: string[] = null, players: any, seletorCampoJogador: string = '#jogador', seletorBusca: string = "#searchclear") {
      var form: JQuery = $(seletorCampoJogador).parents('form');
      if (maskedDefId && maskedDefId.length) {
        form.find(seletorBusca).click();
        $.each(maskedDefId, (index: any, value: string | number) => {
          var player = App.Util.getItemArrayById(players, parseInt(value.toString()));
          var option = new Option(JSON.stringify(player), player.id, true, true);
          option.title = player.hasOwnProperty('c') ? player.c : player.f + ' ' + player.l;
          form.find(seletorCampoJogador).append(option).trigger('change').trigger('select2:select');
        });
      }
    }

    public setCampoJogadorFiltroPro(maskedDefId: string[] = null, players: any, elContexto: JQuery, seletorBusca: string) {
      var form: JQuery = elContexto.parents('form');
      if (maskedDefId && maskedDefId.length) {
        form.find(seletorBusca).click();
        $.each(maskedDefId, (index: any, value: string | number) => {
          var player = App.Util.getItemArrayById(players, parseInt(value.toString()));
          var option = new Option(JSON.stringify(player), player.id, true, true);
          option.title = player.hasOwnProperty('c') ? player.c : player.f + ' ' + player.l;
          elContexto.append(option).trigger('change').trigger('select2:select');
        });
      }
    }

    private aoAlterarVariacaoPrecoCompra(e: JQueryEventObject) {
      var variacao = App.Util.obterInteiroDaString($(e.target).val());
      var campoPrecoTotal = App.Util.obterInteiroDaString($(e.target).parents('.modal').find('input[name=maxBuyNow]').val())
      let variacaoMaxima = campoPrecoTotal;
      if (campoPrecoTotal && variacao && variacao >= 1) {
        variacaoMaxima = Util.getPrecoVariacaoMax(campoPrecoTotal, variacao)
        $(e.target).parents('.espaco-campo-variar').find('.input-group').css({ 'opacity': '1' });
        $(e.target).parents('form').find('.preco-max-variacao').html(`=${variacaoMaxima.toString()}`)
        $(e.target).parents('form').find('.preco-max-variacao').show()
      } else {
        $(e.target).parents('.espaco-campo-variar').find('.input-group').css({ 'opacity': '0.4' });
        $(e.target).parents('form').find('.preco-max-variacao').html(``)
        $(e.target).parents('form').find('.preco-max-variacao').hide()
      }

      this.alterarLimitesPrecoCompra(e, variacaoMaxima)
    }

    private alterarLimitesPrecoCompra(e: JQueryEventObject, variacaoMaxima: number) {
      if (!variacaoMaxima || variacaoMaxima <= 200) {
        $(e.target).parents('form').find('input[name=limite_compra_min]').val('');
        $(e.target).parents('form').find('input[name=limite_compra_max]').val('');
        return;
      }

      // o valor max vai ser igual variacaoMaxima + 30%
      // o valor min vai ser igual variacaoMaxima - 30%
      let valorMinimo = Math.floor(variacaoMaxima - (variacaoMaxima * (App.Util.config.porcentagemDefaultLimiteCompraMin || 0.5)));
      let valorMaximo = Math.ceil(variacaoMaxima + (variacaoMaxima * (App.Util.config.porcentagemDefaultLimiteCompraMax || 0.3)));

      // Garantir que valorMinimo não seja menor que 200
      if (valorMinimo < 200) {
        valorMinimo = 200;
      }

      // Garantir que valorMaximo não seja maior que 15 milhões
      if (valorMaximo > 15000000) {
        valorMaximo = 15000000;
      }

      $(e.target).parents('form').find('input[name=limite_compra_min]').val(App.Util.tratarValorDeFiltro(valorMinimo.toString()));
      $(e.target).parents('form').find('input[name=limite_compra_max]').val(App.Util.tratarValorDeFiltro(valorMaximo.toString()));
    }

  }
}
